<template>
  <div class="pub_menu">
    <div class="container1 flex">
      <router-link class="all_menu" to="/category" target="_blank">
        <el-button type="primary">全部产品分类</el-button>
      </router-link>
      <!-- v-show="showSider" -->
      <ul class="menu_item" v-show="showSider" @mouseleave="hideSidebar()">
        <router-link :to="{path:'/category',query: { spaceSerNo: item.serNo }}" target="_blank" v-for="(item, index) in dataMenu" :key="index">
          <li :class="{'item':true,'active':activeIndex == index}" @mouseenter="showSidebar(index)">
            <div class="img">
              <img :src="activeIndex == index ? item.hoverImgUrl : item.imgUrl" alt />
            </div>
            <div class="itr">
              <h4 class="com_link">{{ item.name }}<i class="el-icon-arrow-right sjx"></i></h4>
              <router-link class="text" :to="{path:'/category',query: { categorySerNo: ele.serNo }}" target="_blank" v-for="(ele, num) in item.subMenu" :key="num">
                <span class="com_link">{{ ele.name }}</span>
              </router-link>
            </div>
          </li>
        </router-link>
      </ul>

      <!-- v-show="showSiderContent" -->
      <div class="detail" v-show="showSiderContent" @mouseenter="isShowSidebar()" @mouseleave="isHideSidebar()">
        <div class="cate_list">
          <ul class="item">
            <router-link :to="{path:'/category',query: { spaceSerNo: localMenuItem.serNo }}" target="_blank">
              <h4>{{localMenuItem.name}}</h4>
            </router-link>
            <li v-for="(v, i) in localMenuItem.categoryList" :key="i">
              <router-link :to="{path:'/category',query: { categorySerNo: v.serNo }}" target="_blank">
                {{v.name}}
              </router-link>
            </li>
          </ul>
          <ul class="item" v-for="(item, index) in localMenuItem.detailList" :key="index">
            <router-link :to="{path:'/category',query: { categorySerNo: item.serNo }}" target="_blank">
              <h4>{{item.name}}</h4>
            </router-link>
            <li v-for="(v, i) in item.goodsKeyWordsList" :key="i">
              <router-link :to="{path:'/category',query: { searchKey: v }}" target="_blank">
                {{ v }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="swiper">
          <el-carousel class="carousel" height="197px" :autoplay="true" arrow="never" indicator-position="outside">
            <el-carousel-item v-for="(v, i) in localMenuItem.adList" :key="i">
              <router-link :to="{path:'/category',query: { brandSerNos: v.brandInfo.serNo }}" target="_blank">
                <img :src="v.adPhotoFileUrl" />
              </router-link>
            </el-carousel-item>
          </el-carousel>

          <ul class="brand">
            <h3>推荐品牌</h3>
            <li v-for="(v, i) in localMenuItem.adList" :key="i">
              <router-link :to="{path:'/category',query: { brandSerNos: v.brandInfo.serNo }}" target="_blank">
                {{v.brandInfo.name}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <el-menu :default-active="activeMenuIndex" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="/home">
          <router-link target="_blank" to="/home">首页</router-link>
        </el-menu-item>
        <el-menu-item index="/brandHall" v-if="$store.getters.userTypeA">
          <router-link target="_blank" to="/brandHall">品牌馆</router-link>
        </el-menu-item>
        <el-menu-item index="/wholeBag">
          <router-link target="_blank" to="/wholeBag">整装拎包</router-link>
        </el-menu-item>
        <el-menu-item index="/styleHall" @mouseenter.native="onMouseenterStyle" @mouseleave.native="onMouseleaveStyle">
          <router-link target="_blank" to="/styleHall">风格馆</router-link>
        </el-menu-item>
        <!-- <el-menu-item index="/electricBag">
          <router-link target="_blank" to="/electricBag">电器套餐</router-link>
        </el-menu-item> -->
        <!-- <el-menu-item index="/houseElectrical">
          <router-link target="_blank" to="/houseElectrical">智能家电</router-link>
        </el-menu-item> -->
        <el-menu-item index="/brandSerNos">
          <router-link target="_blank" to="/brandHall/brandCategory?brandSerNos=1">电器馆</router-link>
        </el-menu-item>
        <el-menu-item index="/joinUs">
          <router-link target="_blank" to="/joinUs">加盟我们</router-link>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- v-show="showStyleHall" -->
    <div class="menu_style_hall" v-show="showStyleHall">
      <div class="menu_style_title" @mouseenter="onMouseenterStyle" @mouseleave="onMouseleaveStyle">风格快速筛选</div>
      <div class="menu_style_content container1" @mouseenter="onMouseenterStyle" @mouseleave="onMouseleaveStyle">
        <div class="item" v-for="(item,index) in styleList" :key="index">
          <p class="title">{{item.name}}</p>
          <ul class="list">
            <li class="com_link" v-for="(v,i) in item.childStyle" :key="i" @click="linkStyle(v.serNo)">{{v.name}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetGoodsSpaceNav,
  GetAdPosAndType,
  GetAllStyleInfo,
} from "@/pages/page1/api/modules/home";
export default {
  name: "PublicMenu",
  data() {
    return {
      activeMenuIndex: "1", //首页菜单索引
      menuImgList: [
        {
          imgUrl: require("@/assets/img/icon-6.png"),
          hoverImgUrl: require("@/assets/img/icon-12.png"),
          name: "客厅",
        },
        {
          imgUrl: require("@/assets/img/icon-7.png"),
          hoverImgUrl: require("@/assets/img/icon-13.png"),
          name: "卧室",
        },
        {
          imgUrl: require("@/assets/img/icon-8.png"),
          hoverImgUrl: require("@/assets/img/icon-14.png"),
          name: "餐厅",
        },
        {
          imgUrl: require("@/assets/img/icon-9.png"),
          hoverImgUrl: require("@/assets/img/icon-15.png"),
          name: "书房",
        },
        {
          imgUrl: require("@/assets/img/icon-10.png"),
          hoverImgUrl: require("@/assets/img/icon-16.png"),
          name: "青少年家具",
        },
        {
          imgUrl: require("@/assets/img/icon-11.png"),
          hoverImgUrl: require("@/assets/img/icon-17.png"),
          name: "装饰家具",
        },
        {
          imgUrl: require("@/assets/img/icon-11.png"),
          hoverImgUrl: require("@/assets/img/icon-17.png"),
          name: "智能家居",
        },
      ],
      dataMenu: [],
      showSider: false, //是否显示左侧栏
      showSiderContent: false,
      siderLocalIndex: 0, // 当前左侧栏索引，用来传数据
      activeIndex: -1, // 控制左侧栏激活类和更换图片
      cacheIndex: -1, // 缓存当前左侧栏索引
      showStyleHall: false, //风格馆hover
      styleList: [],
    };
  },
  mounted() {
    let path = this.$route.path;
    if (path === "/home") {
      this.showSider = true;
    } else {
      this.showSider = false;
    }
    let resData = this.$configId;
    let data = resData.goodsSpaceNav;
    let goodsSpaceIdArr = [];
    let goodsSpaceIdStr = "";
    for (const key in data) {
      if (data[key]) {
        goodsSpaceIdArr.push(data[key]);
      }
    }
    goodsSpaceIdStr = goodsSpaceIdArr.join(",");
    this.getSliderMenu(goodsSpaceIdStr);
    this.getAlgStyleInfo();
  },
  methods: {
    getSliderMenu(id) {
      GetGoodsSpaceNav({ goodsSpaceId: id }).then((res) => {
        // console.log("获取商品空间导航", res);
        res.data.forEach((item) => {
          this.menuImgList.forEach((ele) => {
            // 名称相等push进去data
            if (item.name == ele.name) {
              this.$set(item, "imgUrl", ele.imgUrl);
              this.$set(item, "hoverImgUrl", ele.hoverImgUrl);
              this.$set(item, "subMenu", []);
              this.$set(item, "detailList", []);
              this.$set(item, "adList", []);
              item.categoryList.forEach((v, i) => {
                if (i <= 2) {
                  item.subMenu.push({
                    name: v.name,
                    id: v.id,
                    serNo: v.serNo,
                    goodsKeyWordsList: v.goodsKeyWordsList,
                  });
                }
              });
              // 右侧分类
              item.detailList = item.subMenu.slice(0, 2);
            }
          });
        });
        this.dataMenu = res.data;
        let adPositionId = this.$configId.adPositionId;
        // 获取推荐品牌广告位内容
        this.dataMenu.forEach((item) => {
          this.getAdPosAndType(adPositionId.spaceCategory, item.name, item);
        });
      });
    },
    getAdPosAndType(id, name, item) {
      let params = {
        adPositionId: id,
        contentType: 3,
        contentCount: 6,
        themeTitle: name,
      };
      GetAdPosAndType(params).then((res) => {
        // console.log("主题标题获取", res);
        item.adList = res.data;
      });
    },
    showSidebar(index) {
      //显示左侧栏
      this.showSider = true;
      this.showSiderContent = true;
      // 左侧栏索引用来传数据
      this.siderLocalIndex = index;
      // 左侧栏索引用来激活hover类
      this.activeIndex = index;
      // 缓存当前左侧栏索
      this.cacheIndex = index;
    },
    hideSidebar() {
      // 隐藏左侧栏
      if (this.$route.path !== "/home") {
        this.showSider = false;
      }
      this.showSiderContent = false;
      //默认传给右边数据
      // this.siderLocalIndex = 0;
      //还原激活类
      this.activeIndex = -1;
    },
    isShowSidebar() {
      //显示左侧栏
      this.showSider = true;
      this.showSiderContent = true;
      // 左侧栏索引用来激活hover类
      this.activeIndex = this.cacheIndex;
    },
    isHideSidebar() {
      //隐藏左侧栏
      if (this.$route.path !== "/home") {
        this.showSider = false;
      }
      this.showSiderContent = false;
      //还原激活类
      this.activeIndex = -1;
      // 缓存归为默认
      this.siderLocalIndex = 0;
      this.cacheIndex = -1;
    },

    onMouseenterStyle() {
      this.showStyleHall = true;
    },
    onMouseleaveStyle() {
      this.showStyleHall = false;
    },
    getAlgStyleInfo() {
      GetAllStyleInfo().then((res) => {
        // console.log("获取风格馆列表", res);
        this.styleList = res.data;
      });
    },
    linkStyle(serNo) {
      let url = "/styleHall";
      let newUrl = this.$router.resolve({
        path: url,
        query: { styleChildSerNo: serNo },
      });
      if (this.$route.path.toLowerCase() === url.toLowerCase()) {
        window.open(newUrl.href, "_self");
        return;
      }
      window.open(newUrl.href, "_blank");
    },
  },
  computed: {
    localMenuItem() {
      let obj = {};
      let resItem = this.dataMenu.find((v, i) => i == this.siderLocalIndex);
      if (resItem) {
        obj = resItem;
      }
      return obj;
    },
  },
};
</script>

<style lang="less" scoped>
.pub_menu {
  width: 100%;
  border-bottom: 1px solid @themeColor;
  background: #ffffff;
  position: relative;
  .flex {
    position: relative;
    .all_menu {
      width: 222px;
      height: 36px;
      align-self: flex-end;
      .el-button {
        width: 100%;
        height: 100%;
        padding: 0;
        border-radius: 0;
      }
      // 选择紧接在 all_menu 元素后出现的元素
      &:hover + .menu_item {
        display: block !important;
      }
    }
    .el-menu-demo {
      border: 0;
      height: 36px;
      width: calc(100% - 222px);
      padding-left: 82px;
      box-sizing: border-box;
      .el-menu-item {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        border: 0;
        height: 100%;
        line-height: 28px;
      }
      .router-link-active {
        color: @themeColor;
        font-weight: bold;
      }
    }
    .menu_item {
      width: 222px;
      height: 546px;
      background: #100c07;
      position: absolute;
      top: 100%;
      left: 0;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      z-index: 333;
      a {
        color: #ffffff;
      }
      .item {
        background: #000000;
        width: 100%;
        padding-right: 14px;
        box-sizing: border-box;
        height: 91px;
        box-sizing: border-box;
        border-bottom: 1px solid transparent;
        display: flex;
        align-items: center;
        opacity: 0.85;
        .img {
          width: 80px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
        .itr {
          width: calc(100% - 80px);
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          h4 {
            font-size: 14px;
            line-height: 14px;
            font-weight: 500;
            margin-bottom: 16px;
            position: relative;
            .sjx {
              position: absolute;
              right: 0px;
              top: 0;
              font-size: 14px;
            }
          }
          .text {
            margin-right: 10px;
            line-height: 12px;
            display: inline-block;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .active {
        background-color: #ffffff;
        color: #333333;
        opacity: 1;
        .text {
          color: #333333;
        }
      }
    }
    .detail {
      margin-top: 1px;
      padding: 38px 0 16px 44px;
      height: 545px;
      background: #ffffff;
      box-sizing: border-box;
      box-shadow: 7px 2px 4px 5px rgba(0, 0, 0, 8%);

      position: absolute;
      left: 222px;
      top: 100%;
      z-index: 222;
      opacity: 1;
      color: #333333;
      font-size: 12px;
      display: flex;
      .cate_list {
        overflow: hidden;
        position: relative;
        display: flex;
        padding-right: 10px;
        .item {
          width: 120px;
          h4,
          li {
            line-height: 24px;
            font-size: 12px;
            text-indent: 10px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          h4 {
            line-height: 1;
            font-weight: bold;
            margin-bottom: 20px;
            font-size: 14px;
          }
          a {
            color: #333333;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .swiper {
        width: 184px;
        box-sizing: border-box;
        padding: 0 27px 0 20px;
        position: relative;
        /deep/ .carousel {
          width: 100%;
          height: 247px;
          .el-carousel__indicators {
            .el-carousel__button {
              width: 14px;
              height: 4px;
              background: #333333;
            }
          }
        }
        .brand {
          font-size: 12px;
          color: #333333;
          line-height: 1;
          h3 {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 14px;
          }
          li {
            margin-bottom: 12px;
            a {
              color: #333333;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        &::after {
          display: block;
          content: "";
          width: 1px;
          height: 300px;
          background: #333333;
          opacity: 0.5;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
  .menu_style_hall {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    z-index: 334;
    .menu_style_title {
      width: 100%;
      height: 75px;
      line-height: 75px;
      background: #000000;
      text-align: center;

      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: @themeColor;
    }
    .menu_style_content {
      height: 330px;
      box-sizing: border-box;
      padding: 0 40px 30px 40px;
      overflow: auto;
      background: #ffffff;

      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      scrollbar-width: none; //兼容火狐
      &::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
      .item {
        width: 342px;
        box-sizing: border-box;
        margin: 56px 42px 0 0;
        border-bottom: 1px solid #000000;
        &:nth-child(3n) {
          margin-right: 0;
        }
        &:nth-child(-n + 3) {
          margin-top: 30px;
        }
        .title {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          line-height: 1;
          padding-bottom: 14px;
        }
        .list {
          display: flex;
          flex-wrap: wrap;

          line-height: 28px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #8d8d8d;
          li {
            margin-right: 24px;
          }
        }
      }
    }
  }
}
</style>